import React from 'react';
import { IconButton, withStyles } from '@material-ui/core';
import { GetAppRounded, PrintRounded } from '@material-ui/icons';
import LessonGrid from '@anu/components/LessonGrid';
import Box from '@material-ui/core/Box';
import { coursePropTypes } from '@anu/utilities/transform.course';
import html2pdf from 'html2pdf.js/src';
import PropTypes from 'prop-types';

const ButtonWrapper = withStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBlock: theme.spacing(2),
  },
}))(Box);

const CourseActions = ({
  course,
  actions = ['print', 'download'],
}) => {
  const onDownloadClick = () => {
    // Clone the Anu LMS, so we can change elements.
    const element = document
      .getElementById('anu-application')
      .cloneNode(true);

    // Hide all navigational elements from html2pdf.
    element.querySelectorAll('[data-html2pdf-ignore]').forEach(element => {
      element.style.display = 'none';
    });

    // Add the logo.
    const logo = document.querySelector('.navbar-branding__logo-print').cloneNode();
    logo.style.width = '300px';
    logo.style.marginLeft = '30px';
    element.prepend(logo);

    // Add the footer.
    const footer = document.querySelector('.footer').cloneNode(true);
    footer.style.borderTop = 'none';
    element.append(footer);

    // Generate PDF.
    html2pdf(element, {
      // https://ekoopmans.github.io/html2pdf.js/#options
      margin: .5,
      filename: course.title.replace(' ', '-').toLowerCase() + '.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      // https://rawgit.com/MrRio/jsPDF/master/docs/jsPDF.html
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    });
  };

  const onPrintClick = () => {
    // Trigger print.
    // Prints styles are controlled by `@media print` and `displayPrint`.
    window.print();
  };

  return (
    <LessonGrid>
      <ButtonWrapper>
        {actions.includes('download') && <IconButton
          onClick={onDownloadClick}
          aria-label={Drupal.t('Download PDF')}
          style={{ borderRadius: '4px' }}
        >
          <GetAppRounded/>
          <span style={{fontSize:'18px', marginLeft: '5px'}}>Download</span>
        </IconButton>}
        {actions.includes('print') && <IconButton
            onClick={onPrintClick}
            aria-label={Drupal.t('Print the summary')}
            style={{ borderRadius: '4px' }}
        >
          <PrintRounded/>
          <span style={{fontSize:'18px', marginLeft: '5px'}}>Print</span>
        </IconButton>}
      </ButtonWrapper>
    </LessonGrid>
  );
};

CourseActions.propTypes = {
  course: coursePropTypes,
  actions: PropTypes.arrayOf(PropTypes.string),
};

export default CourseActions;
